import authInstance from "config/axios.config";

export const globalConfigServices = {
  getGlobalConfig: async () => {
    const res = await authInstance.get("/admin/configuration-settings");
    return res.data;
  },

  updateGlobalConfig: async (configData) => {
    const res = await authInstance.patch("/admin/update-configuration-settings", configData);
    return res.data;
  },

  resetGlobalConfig: async () => {
    const res = await authInstance.post("/admin/reset-configuration-settings");
    return res.data;
  },
};